import { useState } from "react";
import "./Terms.css";

const TermsAndConditions = () => {
  const [expanded, setExpanded] = useState<string | null>("panel1");

  const togglePanel = (panel: string) => {
    setExpanded(expanded === panel ? null : panel);
  };

  return (
    <div className="legal-page">
      <div className="legal-header">
        <div className="legal-container">
          <div className="breadcrumb">
            <span className="icon">🏠</span>
            <a href="/">Home</a>
            <span className="icon">›</span>
            <span>Terms and Conditions</span>
          </div>

          <h1 className="legal-title">Terms and Conditions</h1>
          <p className="legal-subtitle">Last Updated: November 21, 2025</p>
        </div>
      </div>

      <div className="legal-container">
        <div className="intro-box">
          <p>
            Welcome to Learn and Innovate Technologies Limited (LICO). These Terms
            and Conditions govern your use of our services, website, and any
            related platforms. By accessing or using our services, you agree to
            be bound by these terms.
          </p>
        </div>

        <div className="accordion-group">
          <div
            className={`accordion-item ${
              expanded === "panel1" ? "active" : ""
            }`}
          >
            <button
              className="accordion-header"
              onClick={() => togglePanel("panel1")}
            >
              <span>1. Acceptance of Terms</span>
              <span className="icon">{expanded === "panel1" ? "−" : "+"}</span>
            </button>
            <div className="accordion-content">
              <p>
                By accessing and using LICO's services, including our training
                programs, solar energy solutions, software development services,
                and real estate advisory, you acknowledge that you have read,
                understood, and agree to be bound by these Terms and Conditions.
              </p>
              <p>
                If you do not agree with any part of these terms, you must not
                use our services. We reserve the right to modify these terms at
                any time, and continued use of our services constitutes
                acceptance of any changes.
              </p>
            </div>
          </div>

          <div
            className={`accordion-item ${
              expanded === "panel2" ? "active" : ""
            }`}
          >
            <button
              className="accordion-header"
              onClick={() => togglePanel("panel2")}
            >
              <span>2. Services Overview</span>
              <span className="icon">{expanded === "panel2" ? "−" : "+"}</span>
            </button>
            <div className="accordion-content">
              <h4>2.1 Training Services</h4>
              <p>
                Our training programs include business skills, technical
                education, entrepreneurship development, and professional
                development courses. Course content, schedules, and
                methodologies may be updated to reflect industry changes.
              </p>

              <h4>2.2 Solar Energy Solutions</h4>
              <p>
                We provide solar system design, installation, maintenance, and
                consultation services. All installations are subject to site
                assessment, regulatory compliance, and technical feasibility.
              </p>

              <h4>2.3 Software Development</h4>
              <p>
                Custom software solutions are developed based on agreed
                specifications. Projects are subject to scope definition,
                milestone approvals, and change request procedures.
              </p>

              <h4>2.4 Real Estate Services</h4>
              <p>
                Property advisory, sales, acquisitions, and investment
                consulting services are provided based on market conditions and
                regulatory compliance. LICO acts as an advisor and intermediary.
              </p>
            </div>
          </div>

          <div
            className={`accordion-item ${
              expanded === "panel3" ? "active" : ""
            }`}
          >
            <button
              className="accordion-header"
              onClick={() => togglePanel("panel3")}
            >
              <span>3. Payment Terms</span>
              <span className="icon">{expanded === "panel3" ? "−" : "+"}</span>
            </button>
            <div className="accordion-content">
              <p>
                All services require payment as specified in individual service
                agreements. Payment terms may include upfront deposits,
                milestone payments, or full payment before service delivery
                depending on the service type.
              </p>
              <p>
                Training programs require payment before course commencement.
                Solar installations require deposit upon agreement and balance
                upon completion. Software projects follow milestone-based
                payment structures. Real estate transactions follow
                industry-standard commission and fee structures.
              </p>
              <p>
                Late payments may incur additional charges. Refund policies are
                service-specific and outlined in individual service agreements.
              </p>
            </div>
          </div>

          <div
            className={`accordion-item ${
              expanded === "panel4" ? "active" : ""
            }`}
          >
            <button
              className="accordion-header"
              onClick={() => togglePanel("panel4")}
            >
              <span>4. Client Responsibilities</span>
              <span className="icon">{expanded === "panel4" ? "−" : "+"}</span>
            </button>
            <div className="accordion-content">
              <p>
                Clients are responsible for providing accurate information,
                timely feedback, and necessary access for service delivery. For
                training programs, clients must meet attendance requirements.
                For solar installations, clients must ensure site accessibility
                and obtain necessary permissions.
              </p>
              <p>
                For software development, clients must provide clear
                requirements and timely approvals. For real estate services,
                clients must provide accurate financial information and
                documentation.
              </p>
            </div>
          </div>

          <div
            className={`accordion-item ${
              expanded === "panel5" ? "active" : ""
            }`}
          >
            <button
              className="accordion-header"
              onClick={() => togglePanel("panel5")}
            >
              <span>5. Intellectual Property Rights</span>
              <span className="icon">{expanded === "panel5" ? "−" : "+"}</span>
            </button>
            <div className="accordion-content">
              <p>
                All training materials, course content, software code, designs,
                and documentation created by LICO remain the intellectual
                property of LICO unless otherwise specified in writing. Clients
                receive usage rights as defined in individual service
                agreements.
              </p>
              <p>
                Custom software developed for clients includes licensing terms
                specified in the project agreement. Clients may not reproduce,
                distribute, or modify LICO's proprietary materials without
                written permission.
              </p>
            </div>
          </div>

          <div
            className={`accordion-item ${
              expanded === "panel6" ? "active" : ""
            }`}
          >
            <button
              className="accordion-header"
              onClick={() => togglePanel("panel6")}
            >
              <span>6. Warranties and Disclaimers</span>
              <span className="icon">{expanded === "panel6" ? "−" : "+"}</span>
            </button>
            <div className="accordion-content">
              <p>
                LICO provides services with professional care and expertise.
                However, we do not guarantee specific outcomes, job placements,
                revenue increases, or investment returns. Training outcomes
                depend on individual effort and application.
              </p>
              <p>
                Solar installations are warranted according to manufacturer
                specifications and industry standards. Software is provided with
                specified warranty periods for bug fixes and technical support.
                Real estate advisory is based on available market information
                and does not constitute guaranteed investment advice.
              </p>
            </div>
          </div>

          <div
            className={`accordion-item ${
              expanded === "panel7" ? "active" : ""
            }`}
          >
            <button
              className="accordion-header"
              onClick={() => togglePanel("panel7")}
            >
              <span>7. Limitation of Liability</span>
              <span className="icon">{expanded === "panel7" ? "−" : "+"}</span>
            </button>
            <div className="accordion-content">
              <p>
                LICO's liability is limited to the amount paid for the specific
                service in question. We are not liable for indirect,
                consequential, or incidental damages including lost profits,
                business interruption, or data loss.
              </p>
              <p>
                Force majeure events, government actions, natural disasters, or
                circumstances beyond our reasonable control exempt LICO from
                liability for service delays or interruptions.
              </p>
            </div>
          </div>

          <div
            className={`accordion-item ${
              expanded === "panel8" ? "active" : ""
            }`}
          >
            <button
              className="accordion-header"
              onClick={() => togglePanel("panel8")}
            >
              <span>8. Termination</span>
              <span className="icon">{expanded === "panel8" ? "−" : "+"}</span>
            </button>
            <div className="accordion-content">
              <p>
                Either party may terminate services according to the terms
                specified in individual service agreements. Termination does not
                relieve clients of payment obligations for services already
                rendered.
              </p>
              <p>
                LICO reserves the right to terminate services immediately for
                breach of terms, non-payment, or conduct that damages LICO's
                reputation or interests.
              </p>
            </div>
          </div>

          <div
            className={`accordion-item ${
              expanded === "panel9" ? "active" : ""
            }`}
          >
            <button
              className="accordion-header"
              onClick={() => togglePanel("panel9")}
            >
              <span>9. Governing Law</span>
              <span className="icon">{expanded === "panel9" ? "−" : "+"}</span>
            </button>
            <div className="accordion-content">
              <p>
                These Terms and Conditions are governed by the laws of the
                Federal Republic of Nigeria. Any disputes arising from these
                terms or our services shall be resolved through arbitration in
                accordance with Nigerian arbitration laws.
              </p>
            </div>
          </div>

          <div
            className={`accordion-item ${
              expanded === "panel10" ? "active" : ""
            }`}
          >
            <button
              className="accordion-header"
              onClick={() => togglePanel("panel10")}
            >
              <span>10. Contact Information</span>
              <span className="icon">{expanded === "panel10" ? "−" : "+"}</span>
            </button>
            <div className="accordion-content">
              <p>
                For questions regarding these Terms and Conditions, please
                contact us at:
              </p>
              <div className="contact-info">
                <div className="contact-item">
                  <span className="icon">✉️</span>
                  <span>legal@licotech.com</span>
                </div>
                <div className="contact-item">
                  <span className="icon">📞</span>
                  <span>+234 907 880 1125</span>
                </div>
                <div className="contact-item">
                  <span className="icon">📍</span>
                  <span>Port Harcourt, Rivers State, Nigeria</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="acknowledgment-box">
          <h3>Acknowledgment</h3>
          <p>
            By using LICO's services, you acknowledge that you have read and
            understood these Terms and Conditions and agree to be bound by them.
            These terms constitute a legally binding agreement between you and
            Learn and Innovate Technologies Limited.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
